import {BaseActionClassModel} from "../base-action-class.model";
import {ActionEnum} from "../action.enum";

export namespace CommunityRights {

  export class SetPrivileges extends BaseActionClassModel {
    static readonly type: ActionEnum = ActionEnum.COMMUNITY_RIGHTS_SET_PRIVILEGES;
  }

  export class SetCommunity extends BaseActionClassModel {
    static readonly type: ActionEnum = ActionEnum.COMMUNITY_RIGHTS_SET_COMMUNITY
  }
}
